import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClientsComponent } from "./clients.component";
import { PopulationsComponent } from "./client/populations/populations.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "../../shared/shared.module";
import { PopulationTaxpayersComponent } from './population-taxpayers/population-taxpayers.component';
import { ClientRouteResolver } from "./client/client-route-resolver.service";
import { PopulationRouteResolver } from "./population-taxpayers/population-route-resolver.service";
import { AuthGuard } from "../login/auth-guard/auth.guard";
import { PopulationRulesComponent } from "./client/populations/population-rules/population-rules.component";
import { ConfirmDeactivateGuard } from "./client/populations/population-rules/route-guard";
import { PopulationRulesService } from "./client/populations/population-rules/population-rules.service";
import { PopulationRulesResolver } from "./client/populations/population-rules/population-rules-resolver.service";
import { OrderByPipe } from "../../shared/pipes/order-by.pipe";
import { RemoveEmptyKeyPipe } from "../../shared/pipes/remove-empty-key.pipe";
import { DynamicSourcesDropdownComponent } from "../dynamic-sources-dropdown/dynamic-sources-dropdown.component";
import { PopulationNotesComponent } from "./client/populations/population-notes/population-notes.component";
import { MatSelectModule } from "@angular/material/select";
import { ClientTaxpayersComponent } from './client-taxpayers/client-taxpayers.component';
import { BatchWarningsComponent } from "../tax-returns/tax-return/batch-warnings/batch-warnings.component";
import { BatchOverridesComponent } from "../tax-returns/tax-return/batch-overrides/batch-overrides.component";
import { TenantConfigService } from "../../shared/services/tenant-config.service";
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

const clientsRoutes: Routes = [
  {
    path: "clients",
    component: ClientsComponent,
    data: {
      hideSidebar: true,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "clients/:clientId",
    redirectTo: "clients/:clientId/populations"
  },
  {
    path: "clients/:clientId/populations",
    component: PopulationsComponent,
    data: {
      routeName: 'client',
      client: null
    },
    resolve: {
      client: ClientRouteResolver
    },
    canActivate: [AuthGuard],
  },
  {
    path: "clients/:clientId/populations/:populationId/rules",
    component: PopulationRulesComponent,
    data: {
      routeName: 'population-rules',
    },
    resolve: {
      client: ClientRouteResolver,
      population: PopulationRulesResolver,
    },
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard]
  },
  {
    path: "clients/:clientId/populations/:populationId/notes",
    component: PopulationNotesComponent,
    data: {
      routeName: 'population',
    },
    resolve: {
      client: ClientRouteResolver,
      population: PopulationRouteResolver,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "clients/:clientId/dynamic-sources-dropdown",
    component: DynamicSourcesDropdownComponent,
    data: {
      routeName: 'client'
    },
    canActivate: [AuthGuard],
    resolve: {
      client: ClientRouteResolver
    },
  },

  {
    path: "clients/:clientId/batch-warnings/:batchId",
    component: BatchWarningsComponent,
    data: {
      routeName: 'client'
    },
    canActivate: [AuthGuard],
    resolve: {
      client: ClientRouteResolver
    },
  },
  {
    path: "clients/:clientId/batch-overrides/:batchId",
    component: BatchOverridesComponent,
    data: {
      routeName: 'client'
    },
    canActivate: [AuthGuard],
    resolve: {
      client: ClientRouteResolver
    },
  },
];

TenantConfigService.getTaxpayerAliasPaths().forEach(path => {
  clientsRoutes.push(
    {
      path: `clients/:clientId/populations/:populationId/${path}`,
      component: PopulationTaxpayersComponent,
      data: {
        routeName: 'population',
      },
      resolve: {
        client: ClientRouteResolver,
        population: PopulationRouteResolver,
      },
      canActivate: [AuthGuard],
    },
    {
      path: `clients/:clientId/${path}`,
      component: ClientTaxpayersComponent,
      data: {
        routeName: 'client'
      },
      canActivate: [AuthGuard],
      resolve: {
        client: ClientRouteResolver
      },
    },
  );
});


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(clientsRoutes, {}),
    MatSelectModule,
    TranslocoModule,
  ],
  declarations: [
    ClientsComponent,
    PopulationsComponent,
    PopulationTaxpayersComponent,
    PopulationNotesComponent,
    ClientTaxpayersComponent
  ],
  providers: [
    ClientRouteResolver,
    PopulationRouteResolver,
    PopulationRulesResolver,
    {
      provide: 'CanNeverActivateGuard',
      useValue: () => {
        return false;
      }
    },
    PopulationRulesService,
    ConfirmDeactivateGuard,
    OrderByPipe,
    RemoveEmptyKeyPipe,
    { provide: TRANSLOCO_SCOPE, useValue: 'clients' },
  ]
})
export class ClientsModule {
}
